module.exports = __webpack_public_path__ + "img/临时搜索.596d49f0.png";